// @ts-nocheck
/* eslint-disable */
import axios from 'axios';
import qs from 'qs';
import { Dispatch } from 'redux';
import { FluxStandardAction } from 'redux-promise-middleware';

import { tripSaleConstants } from '_constants';

interface TripSaleQueryParams {
  group_ids?: string[];
  sortBy?: string;
  sortOrder?: string;
  q?: {
    ticket_serial_cont?: string;
    driver_username_or_driver_first_name_or_driver_last_name_cont_any?: string | string[];
    axis_code_cont_any?: string | string[];
    vehicle_code_cont_any?: string | string[];
    groups?: string;
    created_at_gteq?: string;
    created_at_lteq?: string;
    obc_time_gteq?: string;
    obc_time_lteq?: string;
    discount_band_code_cont_any?: string | string[];
    discount_band_assignments_id_in?: string | string[];
    is_offline_eq?: string;
  };
}

const getTripSales =
  (page: number, size: number, queryParams?: TripSaleQueryParams) =>
  (dispatch: Dispatch): FluxStandardAction => {
    const pageNumber = page + 1;

    // We target the Node.js backend directly (REACT_APP_ABT_ALL_APIS_BASE_URL)
    // because the Ruby API (/v2/trip_payment_operations) is being replaced by
    // our new paginated endpoint that also returns discount columns.
    const baseURL = process.env.REACT_APP_ABT_ALL_APIS_BASE_URL;

    let userAuthData: any = null;
    try {
      const localAuthData = localStorage.getItem('authData');
      if (localAuthData) {
        const parsed = JSON.parse(localAuthData);
        userAuthData = parsed?.userToken;
      }
    } catch (_e) {
      // ignore
    }

    const request = axios.get(
      `${baseURL}/api/v1/web_portal/financialControl/tripSales/trip_payment_operations`,
      {
        params: {
          page: pageNumber,
          page_count: size,
          ...queryParams,
        },
        paramsSerializer: (params) =>
          qs.stringify(params, { arrayFormat: 'brackets' }),
        headers: {
          'access-token': userAuthData?.['access-token'] || userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
          Authorization: `Bearer ${localStorage.getItem('dashboard_token')}`,
        },
      }
    );

    return dispatch({
      type: tripSaleConstants.GET_TRIP_SALES,
      payload: request,
      meta: { page: pageNumber },
    });
  };

export { getTripSales };
